 import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ChatDialogData } from "../../../types/telegran-chat-modal.types";
import { BaseModalComponent } from "../../../../../../core/components/modals/base-modal/base-modal.component";
import { telegramResourceType } from "../../../configs/telegram-page-config";
import { SendMessageQueryParams, UserChatQueryParams } from "../../../types/telegram-page.types";
import { TelegramService } from "../../../services/telegram.service";
import { ChatTelegram } from "../../../types/chat-telegram.types";
import { MessageTelegram } from "../../../types/last-message.types";
import { TelegramFileUrlService } from "../../../services/telegram-file-url.service";
import { MessagesPollingService } from "../../../services/messages-polling.service";
import { TelegramMessagesService } from "../../../services/telegram-messages.service";
import { TelegramPollingService } from "../../../services/telegram-polling.service";
import { TelegramChatModalService } from "../../../services/telegram-chat-modal.service";
import { TelegramChatsService } from "../../../services/telegram-chats.service";
import { telegramPagePollingInterval } from "../../../../../../core/models/polling-config";
import { telegramChatModalName } from "./configs/telegram-chat-config";
import { LoaderComponent } from "../../../../../../shared/components/loader/loader.component";
 import { TelegramBloggersComponent } from "../../telegram-bloggers/telegram-bloggers.component";
 import { TelegramChatWindowComponent } from "../../telegram-chat-window/telegram-chat-window.component";

@Component({
  selector: 'app-telegram-chat-modal',
  standalone: true,
  imports: [
    BaseModalComponent,
    LoaderComponent,
    TelegramBloggersComponent,
    TelegramChatWindowComponent
  ],
  templateUrl: './telegram-chat-modal.component.html',
  styleUrl: './telegram-chat-modal.component.scss'
})
export class TelegramChatModalComponent extends BaseModalComponent {
  public dialogData = inject<ChatDialogData>(MAT_DIALOG_DATA);
  private telegramService: TelegramService = inject(TelegramService);
  private telegramFileUrlService: TelegramFileUrlService = inject(TelegramFileUrlService);
  private messagesPollingService: MessagesPollingService = inject(MessagesPollingService);
  private telegramMessagesService: TelegramMessagesService = inject(TelegramMessagesService);
  private telegramPollingService: TelegramPollingService = inject(TelegramPollingService);
  private telegramChatModalService: TelegramChatModalService = inject(TelegramChatModalService);
  private telegramChatsService: TelegramChatsService = inject(TelegramChatsService);

  public chat: ChatTelegram | null = null;
  public chats: Array<ChatTelegram> = [];
  public messages: Array<MessageTelegram> = [];
  public isVisibleBloggers: boolean = true;
  private userChatQueryParams: UserChatQueryParams | null = null;

  public override async ngOnInit(): Promise<void> {
    super.ngOnInit();
    this.modalStatesService.openModal(telegramChatModalName);
    this.loadingService.setIsLoadingState(true);
    this.userChatQueryParams = await this.telegramChatModalService.getUserChatQueryParams(this.dialogData.recordCalendarId);
    await this.initializeChatData();
    this.loadingService.setIsLoadingState(false);
  }

  public override ngOnDestroy(): void {
    this.modalStatesService.closeModal(telegramChatModalName);
    this.messagesPollingService.stopPolling();
  }

  public getTitle(): string {
    return `${telegramResourceType.name} по рекламе Id: ${this.dialogData.recordCalendarId}`;
  }

  public async sendMessage(sendMessageQueryParams: SendMessageQueryParams): Promise<void> {
    await this.telegramService.sendMessage(sendMessageQueryParams);
  }

  public toggleBlogger() {
    this.isVisibleBloggers = !this.isVisibleBloggers;
  }

  public async handleSelectChat(chat: ChatTelegram): Promise<void> {
    this.telegramFileUrlService.clearAllUrls();
    this.chat = chat;
    this.telegramChatsService.setChat(chat.id);
    this.messages = await this.telegramMessagesService.loadInitialMessages({
      chatId: chat.id,
      accountId: this.userChatQueryParams?.accountId
    });
    this.startMessagesPolling(chat.id);
  }

  private async initializeChatData(): Promise<void> {
    await this.telegramChatModalService.getAccount(this.userChatQueryParams?.accountId || '');
    await this.telegramChatsService.setChats();
    await this.telegramChatModalService.getChat(this.userChatQueryParams!);
    this.chat = this.telegramChatsService.chat();
    this.chats = this.telegramChatsService.chats();
    await this.handleSelectChat(this.chat!);
  }

  private startMessagesPolling(chatId: number): void {
    const params = this.telegramMessagesService.setMessagesQueryParams(chatId);

    this.telegramPollingService.getMessagesWithPolling({
      params: params,
      intervalMs: telegramPagePollingInterval,
      callback: (messages) => {
        if (this.telegramMessagesService.hasMessagesChanged(messages, this.messages)) {
          this.messages = this.telegramMessagesService.sortMessages(messages);
        }
      }
    });
  }
}
